// import { format } from "date-fns";
// import React, { useContext } from "react";
// import toast from "react-hot-toast";
// import { AuthContext } from "../../../contexts/AuthProvider";
// const BookingModal = ({ treatment, setTreatment, selectedDate, refetch }) => {
//   // treatment is just another name of appointmentOptions with name, slots, _id
//   const { name: tretamentName, slots } = treatment;
//   const date = format(selectedDate, "PP");

//   const { user } = useContext(AuthContext);

//   const handleBooking = (event) => {
//     event.preventDefault();
//     const form = event.target;
//     const slot = form.slot.value;
//     const name = form.name.value;
//     const email = form.email.value;
//     const phone = form.phone.value;
//     // [3, 4, 5].map((value, i) => console.log(value))
//     const booking = {
//       appointmentDate: date,
//       treatment: tretamentName,
//       patient: name,
//       slot,
//       email,
//       phone,
//     };

//     fetch("https://doctors-portal-server-f4faysal.vercel.app/bookings", {
//       // method: "POST",
//       // headers: { "contnt-type": "apliction/json" },
//       // body: JSON.stringify(booking),
//       method: "POST",
//       headers: {
//         "content-type": "application/json",
//       },
//       body: JSON.stringify(booking),
//     }).then((data) => {
//       console.log('data',data);
//       toast.success("Booking confirmed");
//       // if (data.acknowledged) {
//       //   setTreatment(null);
//       //   toast.success("Booking confirmed");
//       //   refetch();
//       // } else {
//       //   toast.error(data.message);
//       // }
//     });

//     // TODO: send data to the server
//     // and once data is saved then close the modal
//     // and display success toast
//     console.log(booking);
//     setTreatment(null);
//   };
//   return (
//     <>
//       <input type="checkbox" id="booking-modal" className="modal-toggle" />
//       <div className="modal">
//         <div className="modal-box relative">
//           <label
//             htmlFor="booking-modal"
//             className="btn btn-sm btn-circle absolute right-2 top-2"
//           >
//             ✕
//           </label>
//           <h3 className="text-lg font-bold">{tretamentName}</h3>
//           <form
//             onSubmit={handleBooking}
//             className="grid grid-cols-1 gap-3 mt-10"
//           >
//             <input
//               type="text"
//               disabled
//               value={date}
//               className="input w-full input-bordered "
//             />
//             <select name="slot" className="select select-bordered w-full">
//               {slots.map((slot, i) => (
//                 <option value={slot} key={i}>
//                   {slot}
//                 </option>
//               ))}
//             </select>
//             <input
//               name="name"
//               type="text"
//               defaultValue={user?.displayName}
//               placeholder="Your Name"
//               className="input w-full input-bordered"
//               disabled
//             />
//             <input
//               name="email"
//               type="email"
//               placeholder="Email Address"
//               defaultValue={user?.email}
//               disabled
//               className="input w-full input-bordered"
//             />
//             <input
//               name="phone"
//               type="text"
//               placeholder="Phone Number"
//               className="input w-full input-bordered"
//             />
//             <br />
//             <input
//               className="btn btn-accent w-full"
//               type="submit"
//               value="Submit"
//             />
//           </form>
//         </div>
//       </div>
//     </>
//   );
// };

// export default BookingModal;

import { format } from "date-fns";
import React, { useContext } from "react";
import toast from "react-hot-toast";
import { AuthContext } from "../../../contexts/AuthProvider";

const BookingModal = ({ treatment, setTreatment, selectedDate, refetch }) => {
  // treatment is just another name of appointmentOptions with name, slots, _id
  const { name: treatmentName, slots , price } = treatment;
  const date = format(selectedDate, "PP");
  const { user } = useContext(AuthContext);

  const handleBooking = (event) => {
    event.preventDefault();
    const form = event.target;
    const slot = form.slot.value;
    const name = form.name.value;
    const email = form.email.value;
    const phone = form.phone.value;
    // [3, 4, 5].map((value, i) => console.log(value))
    const booking = {
      appointmentDate: date,
      treatment: treatmentName,
      patient: name,
      slot,
      email,
      phone,
      price
    };

    // TODO: send data to the server
    // and once data is saved then close the modal
    // and display success toast
    
    fetch("https://doctors-portal-server-f4faysal.vercel.app/bookings", {
      method: "POST",
      headers: {
        "content-type": "application/json",
      },
      body: JSON.stringify(booking),
    })
      .then((res) => res.json())
      .then((data) => {
        console.log(data);
        if (data.acknowledged) {
          setTreatment(null);
          toast.success("Booking confirmed");
          refetch();
        } else {
          toast.error(data.message);
        }
      });
  };

  return (
    <>
      <input type="checkbox" id="booking-modal" className="modal-toggle" />
      <div className="modal">
        <div className="modal-box relative">
          <label
            htmlFor="booking-modal"
            className="btn btn-sm btn-circle absolute right-2 top-2"
          >
            ✕
          </label>
          <h3 className="text-lg font-bold">{treatmentName}</h3>
          <form
            onSubmit={handleBooking}
            className="grid grid-cols-1 gap-3 mt-10"
          >
            <input
              type="text"
              disabled
              value={date}
              className="input w-full input-bordered "
            />
            <select name="slot" className="select select-bordered w-full">
              {slots.map((slot, i) => (
                <option value={slot} key={i}>
                  {slot}
                </option>
              ))}
            </select>
            <input
              name="name"
              type="text"
              defaultValue={user?.displayName}
              disabled
              placeholder="Your Name"
              className="input w-full input-bordered"
            />
            <input
              name="email"
              type="email"
              defaultValue={user?.email}
              disabled
              placeholder="Email Address"
              className="input w-full input-bordered"
            />
            <input
              name="phone"
              type="text"
              placeholder="Phone Number"
              className="input w-full input-bordered"
            />
            <br />
            <input
              className="btn btn-accent w-full"
              type="submit"
              value="Submit"
            />
          </form>
        </div>
      </div>
    </>
  );
};

export default BookingModal;
